import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Wrapper for a data section: search bar + card list + pagination.
 *
 * Props:
 *   searchPlaceholder — placeholder text for the search input
 *   searchValue       — controlled value for the search input
 *   onSearch          — onChange handler for the search input
 *   loading           — boolean; shows skeleton rows when true
 *   empty             — boolean; shows an empty state when true and not loading
 *   emptyMessage      — optional custom empty state message
 *   children          — rendered DataCard components
 *   pagination        — rendered Pagination component (or null)
 *   skeletonCount     — number of skeleton rows to show (default 5)
 */
const DataList = ({
  searchPlaceholder = 'Search…',
  searchValue = '',
  onSearch,
  loading = false,
  empty = false,
  emptyMessage = 'No items found.',
  children,
  pagination,
  skeletonCount = 5,
}) => {
  return (
    <div className="data-list">
      {/* Search bar */}
      <div className="data-list-search-row">
        <div className="data-list-search-wrap">
          <i className="bi bi-search data-list-search-icon" />
          <input
            type="text"
            className="data-list-search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={onSearch}
            aria-label={searchPlaceholder}
          />
        </div>
      </div>

      {/* Content */}
      <div className="data-list-items">
        {loading ? (
          Array.from({ length: skeletonCount }).map((_, i) => (
            <div key={i} className="data-list-skeleton-row">
              <Skeleton height={54} borderRadius={8} />
            </div>
          ))
        ) : empty ? (
          <div className="data-list-empty">
            <i className="bi bi-folder-x data-list-empty-icon" />
            <span className="data-list-empty-msg">{emptyMessage}</span>
          </div>
        ) : (
          children
        )}
      </div>

      {/* Pagination */}
      {!loading && !empty && pagination && (
        <div className="data-list-pagination">
          {pagination}
        </div>
      )}
    </div>
  );
};

export default DataList;
